module.exports = __webpack_public_path__ + "img/participation.5109f51b.svg";